import styles from './AppCkeckbox.module.scss'

interface AppCkeckboxProps {
  title?: string
  label: string
  checked: boolean
  onChange: (checked: boolean) => void
}
export const AppCkeckbox = ({
  title,
  label,
  checked,
  onChange,
}: AppCkeckboxProps) => {
  return (
    <label className={styles.container}>
      {title && <div className={styles.label}>{title}&nbsp;</div>}
      <div className={styles.field}>
        <input
          type="checkbox"
          checked={checked}
          onChange={() => onChange(!checked)}
        />
        {label}
      </div>
    </label>
  )
}
